import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "navbar__section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PInvitation = _resolveComponent("PInvitation")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", {
        class: _normalizeClass([{ 'no-margin-last-child': !_ctx.hasActivePhysicalUserCard }, "navbar__list a-font__nav"])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navbarItems, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.name,
            class: "navbar__item"
          }, [
            (_openBlock(), _createBlock(_component_router_link, {
              key: index,
              class: _normalizeClass(["navbar__link", { main: index === 0 }]),
              to: item.path,
              onClick: ($event: any) => (_ctx.onNavClick(item.path))
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon))),
                _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
              ]),
              _: 2
            }, 1032, ["class", "to", "onClick"]))
          ]))
        }), 128))
      ], 2)
    ]),
    _createVNode(_component_BaseDialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
      width: "1137"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PInvitation, { onClose: _ctx.popupClose }, null, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}